import { EXPERIENCE_DOMAIN_CONFIG, EXPERIENCE_HOST_DOMAINS } from './domainConfig';

export const hjsv = 6;

type HotjarIdConfig = {
  [key in EXPERIENCE_DOMAIN_CONFIG]: number;
};

export const hotjarIdConfig: HotjarIdConfig = {
  [EXPERIENCE_HOST_DOMAINS.localhost]: 2489096,
  [EXPERIENCE_HOST_DOMAINS.mumbai]: 2489096,
  [EXPERIENCE_HOST_DOMAINS.euDev]: 2489096,
  [EXPERIENCE_HOST_DOMAINS.qa1]: 2489096,
  [EXPERIENCE_HOST_DOMAINS.qa2]: 2489096,
  [EXPERIENCE_HOST_DOMAINS.qa3]: 2489096,
  [EXPERIENCE_HOST_DOMAINS.qa4]: 2489096,
  [EXPERIENCE_HOST_DOMAINS.stagingUS]: 2489096,
  [EXPERIENCE_HOST_DOMAINS.stagingEU]: 2489096,
  [EXPERIENCE_HOST_DOMAINS.uatAM]: 2489094,
  [EXPERIENCE_HOST_DOMAINS.uatEU]: 2489094,
  [EXPERIENCE_HOST_DOMAINS.uatUS]: 2489094,
  [EXPERIENCE_HOST_DOMAINS.au]: 2489094,
  [EXPERIENCE_HOST_DOMAINS.eu]: 2489094,
  [EXPERIENCE_HOST_DOMAINS.us]: 2489094,
  [EXPERIENCE_HOST_DOMAINS.cn]: 2489094,
  [EXPERIENCE_HOST_DOMAINS.au1]: 2489094,
  [EXPERIENCE_HOST_DOMAINS.eu1]: 2489094,
  [EXPERIENCE_HOST_DOMAINS.us1]: 2489094,
  [EXPERIENCE_HOST_DOMAINS.cn1]: 2489094,
};
